import { type ComponentProps } from 'react';

export default function ProgramIcon ({ ...otherProps }: ComponentProps<'svg'>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 579 512' fill='currentColor' {...otherProps}>
      <path d='m445 125.3H.1V0h445v125.3zM588.6 189H143.7v125.3h445V189zM366.2 378H48.2v125.3h317.9V378z' />
    </svg>
  );
}
